import CompanyCard from '@/components/CompanyCard'
import UserCard from '@/components/UserCard'
import Vue from 'vue'
import appConfig from '@/config.js'
import { getCountries } from '@/services/country'

const codTransactionsModel = vm => ({
  title: vm.$gettext('COD Transactions'),
  endpoint: 'cod-transactions',
  noIdLink: true,
  countrizeById: 'country_id',
  asyncCsvReport: false,
  fields: [
    {
      key: 'id'
    },
    {
      key: 'user_id',
      label: vm.$gettext('User'),
      formatter: (value, key, item) => {
        return new Vue({
          ...UserCard,
          parent: this,
          propsData: {
            user: item.user,
            profilePicture: false,
            withTitles: false,
            withMap: false
          }
        }).$mount().$el.outerHTML
      }
    },
    {
      key: 'lol',
      label: vm.$gettext('Company'),
      formatter: (value, key, item) => {
        return new Vue({
          ...CompanyCard,
          parent: this,
          propsData: {
            company: item.shipping.company,
            profilePicture: false,
            withTitles: false,
            withContact: false
          }
        }).$mount().$el.outerHTML
      }
    },
    // {
    //   key: 'shipping_service_id'
    // },
    {
      key: 'shipping',
      label: vm.$gettext('Shipping'),
      formatter: (value, key, item) => {
        return (
          '<a href="/edit/shippings/' +
          value.id +
          '" target="_blank">' +
          Vue.options.filters.uuid(value.id) +
          '</a>'
        )
      }
    },
    {
      key: 'cod_payment_id',
      label: vm.$gettext('COD Payment ID')
    },
    {
      key: 'amount',
      label: vm.$gettext('Amount')
    },
    {
      key: 'status',
      label: vm.$gettext('Status'),
      formatter: (value, key, item) => {
        let color = 'info'
        if (value === 'deposited') {
          color = 'success'
        } else if (value !== 'collected') {
          color = 'danger'
        }
        return (
          '<span class="text-' +
          color +
          ' text-nowrap"><span style="display: inline-block; width:5px; height:5px; border-radius: 100px; vertical-align:middle;" class="bg-' +
          color +
          '"></span> ' +
          value +
          '</span>'
        )
      }
    },
    {
      key: 'country_id',
      label: vm.$gettext('Country'),
      sortable: true,
      editable: true,
      formatter: (value, key, item) => {
        return getCountries().find(x => x.id === value).iso_code
      }
    },
    {
      key: 'updated_at',
      label: vm.$gettext('Updated At'),
      sortable: true
    }
  ],
  extraActions: [
    {
      label: vm.$gettext('Lost'),
      type: 'button',
      icon: 'ghost',
      title: vm.$gettext('Mark COD transaction as lost (Stolen or just lost)'),
      variant: 'danger',
      position: 'end',
      disabledCondition: item => {
        return item.status !== 'collected'
      },
      action: item => {
        if (confirm(vm.$gettext('Are you sure you want to MARK AS STOLEN/LOST the COD transaction?'))) {
          Vue.http.put(appConfig.api.baseUrl + 'cod-transactions/' + item.id + '/lost').then(response => {
            window.moovaAdmin.refreshTable('apiListTable')
          })
        }
      }
    },
    {
      label: vm.$gettext('Deposited'),
      type: 'button',
      icon: 'check',
      title: vm.$gettext('Mark COD transaction as RECEIVED'),
      variant: 'success',
      position: 'start',
      visibilityCondition: item => {
        return item.country.cod_provider === 'manual-pod'
      },
      disabledCondition: item => {
        return item.status !== 'collected'
      },
      action: item => {
        if (confirm(vm.$gettext('Are you sure you want to MARK AS RECEIVED the COD transaction?'))) {
          Vue.http.put(appConfig.api.baseUrl + 'cod-transactions/' + item.id + '/paid').then(response => {
            window.moovaAdmin.refreshTable('apiListTable')
          })
        }
      }
    }
  ],
  includes: ['user.roles', 'service', 'shipping', 'payment', 'country'],
  filters: ['id', 'user.name', 'user.email', 'status', 'shipping.company_id', 'updated_at']
})

export default codTransactionsModel
